export interface ShippedLaunchSpec {
  readonly runtimeKey: string;
  readonly file: string;
  readonly args: readonly string[];
  readonly needsModel: boolean;
  readonly env?: Readonly<Record<string, string>>;
}

const KEY = /^[A-Za-z0-9._:/@-]{1,128}$/;
const ENV = /^[A-Z_][A-Z0-9_]*$/;

function plain(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function parseShippedLaunchSpecs(value: unknown): ShippedLaunchSpec[] | null {
  if (!Array.isArray(value) || value.length === 0) return null;
  const seen = new Set<string>();
  const specs: ShippedLaunchSpec[] = [];
  for (const raw of value) {
    if (!plain(raw)) return null;
    if (typeof raw.runtimeKey !== 'string' || !KEY.test(raw.runtimeKey) || seen.has(raw.runtimeKey)) return null;
    if (typeof raw.file !== 'string' || raw.file.length === 0 || /[\r\n]/.test(raw.file)) return null;
    if (!Array.isArray(raw.args) || raw.args.some((arg) => typeof arg !== 'string' || /[\0\r\n]/.test(arg))) return null;
    if (typeof raw.needsModel !== 'boolean') return null;
    let env: Readonly<Record<string, string>> | undefined;
    if (raw.env !== undefined) {
      if (!plain(raw.env)) return null;
      const copied: Record<string, string> = {};
      for (const [name, text] of Object.entries(raw.env)) {
        if (!ENV.test(name) || typeof text !== 'string' || /[\0\r\n]/.test(text)) return null;
        copied[name] = text;
      }
      env = copied;
    }
    seen.add(raw.runtimeKey);
    specs.push({
      runtimeKey: raw.runtimeKey, file: raw.file, args: [...raw.args] as string[], needsModel: raw.needsModel,
      ...(env === undefined ? {} : { env }),
    });
  }
  return specs;
}
